(function () {
  // Filters via a variant-level boolean metafield (custom.immediate_delivery).
  // Requires:
  //   1. Metafield definition: Settings → Custom data → Variants
  //      Namespace: custom | Key: immediate_delivery | Type: True/False
  //   2. Filter enabled: Apps → Search & Discovery → Filters → custom.immediate_delivery
  // The metafield is set per-variant by the set-immediate-delivery-metafield.mjs script.
  var FILTER_PARAM = 'filter.v.m.custom.immediate_delivery';
  var FILTER_VALUE = 'true';

  /* ------- Helpers ------- */

  // The URL is the sole source of truth.
  // sessionStorage is NOT used — it caused the toggle to appear on by default
  // when revisiting the page after a previous session had it enabled.
  function isActive() {
    var params = new URLSearchParams(window.location.search);
    return params.get(FILTER_PARAM) === FILTER_VALUE;
  }

  function buildSearchParams(active) {
    var params = new URLSearchParams(window.location.search);
    if (active) {
      params.set(FILTER_PARAM, FILTER_VALUE);
    } else {
      params.delete(FILTER_PARAM);
    }
    return params.toString();
  }

  function syncToggles(active) {
    document.querySelectorAll('.immediate-delivery-toggle__input').forEach(function (input) {
      input.checked = active;
    });
  }

  /* ------- Toggle change handler ------- */

  function onToggleChange(e) {
    var active = e.target.checked;
    syncToggles(active);

    var searchParams = buildSearchParams(active);

    // Hand off to the existing FacetFiltersForm machinery.
    // Reset searchParamsPrev so it always re-renders regardless of cache state.
    if (typeof FacetFiltersForm !== 'undefined') {
      FacetFiltersForm.searchParamsPrev = null;

      // renderSectionFromCache does NOT fire facets:change (only the fetch path
      // does, in its .finally()). Patch it once so cache hits also fire the
      // event. Use setTimeout so it fires AFTER updateURLHash has run —
      // otherwise isActive() reads the stale URL and sets the wrong toggle state.
      if (!FacetFiltersForm._cacheEventPatched) {
        var originalFromCache = FacetFiltersForm.renderSectionFromCache;
        FacetFiltersForm.renderSectionFromCache = function (filterDataUrl, event) {
          originalFromCache.call(this, filterDataUrl, event);
          setTimeout(function () { FacetFiltersForm.fireCustomEvent(); }, 0);
        };
        FacetFiltersForm._cacheEventPatched = true;
      }

      FacetFiltersForm.renderPage(searchParams, null, true);
    } else {
      window.location.search = searchParams;
    }
  }

  function attachListeners() {
    document.querySelectorAll('.immediate-delivery-toggle__input').forEach(function (input) {
      input.removeEventListener('change', onToggleChange);
      input.addEventListener('change', onToggleChange);
    });
  }

  /* ------- Initialise ------- */

  function init() {
    syncToggles(isActive());
    attachListeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-attach after facet AJAX updates replace the DOM.
  document.addEventListener('facets:change', function () {
    syncToggles(isActive());
    attachListeners();
  });

  // Sync toggle state on browser back/forward.
  window.addEventListener('popstate', function () {
    syncToggles(isActive());
  });
})();
